var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlockContent',{attrs:{"projectId":_vm.sanityProjectId,"dataset":_vm.sanityDataset,"blocks":_vm.content,"serializers":_vm.serializers}})}
var staticRenderFns = []

export { render, staticRenderFns }